interface IconProps {
    width?: string;
    height?: string;
    className?: string;
}

import React from 'react';

const NotifictionsIcon = ({ width = '40', height = '40', className = '' }: IconProps) => {
    return (
        <span className={className}>
            <svg width={width} height={height} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.1" y="0.1" width="39.8" height="39.8" rx="19.9" fill="white" />
                <rect x="0.1" y="0.1" width="39.8" height="39.8" rx="19.9" stroke="white" strokeWidth="0.2" />
                <path
                    d="M20.02 10.9102C16.71 10.9102 14.02 13.6002 14.02 16.9102V19.8002C14.02 20.4102 13.76 21.3402 13.45 21.8602L12.3 23.7702C11.59 24.9502 12.08 26.2602 13.38 26.7002C17.69 28.1402 22.34 28.1402 26.65 26.7002C27.86 26.3002 28.39 24.8702 27.73 23.7702L26.58 21.8602C26.28 21.3402 26.02 20.4102 26.02 19.8002V16.9102C26.02 13.6102 23.32 10.9102 20.02 10.9102Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                />
                <path
                    d="M21.87 11.1999C21.56 11.1099 21.24 11.0399 20.91 10.9999C19.95 10.8799 19.03 10.9499 18.17 11.1999C18.46 10.4599 19.18 9.93994 20.02 9.93994C20.86 9.93994 21.58 10.4599 21.87 11.1999Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M23.02 27.0601C23.02 28.7101 21.67 30.0601 20.02 30.0601C19.2 30.0601 18.44 29.7201 17.9 29.1801C17.36 28.6401 17.02 27.8801 17.02 27.0601"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                />
                <rect x="20.999" y="9" width="10" height="10" rx="5" fill="#E81E1E" />
                <path
                    d="M25.9732 16.06C25.8212 16.06 25.6632 16.05 25.4992 16.03C25.3392 16.014 25.1852 15.994 25.0372 15.97C24.8932 15.946 24.7732 15.922 24.6772 15.898L24.7192 15.442C24.8112 15.458 24.9252 15.476 25.0612 15.496C25.1972 15.512 25.3392 15.528 25.4872 15.544C25.6392 15.556 25.7792 15.562 25.9072 15.562C26.1792 15.562 26.3812 15.504 26.5132 15.388C26.6452 15.272 26.7112 15.098 26.7112 14.866C26.7112 14.702 26.6772 14.572 26.6092 14.476C26.5452 14.38 26.4552 14.31 26.3392 14.266C26.2272 14.222 26.0992 14.198 25.9552 14.194H25.1572V13.708H25.9492C26.0492 13.708 26.1512 13.684 26.2552 13.636C26.3592 13.584 26.4452 13.51 26.5132 13.414C26.5852 13.314 26.6212 13.196 26.6212 13.06C26.6212 12.852 26.5612 12.704 26.4412 12.616C26.3252 12.524 26.1312 12.478 25.8592 12.478C25.7312 12.478 25.5992 12.484 25.4632 12.496C25.3272 12.508 25.1992 12.524 25.0792 12.544C24.9592 12.56 24.8572 12.576 24.7732 12.592L24.7372 12.142C24.8172 12.118 24.9212 12.094 25.0492 12.07C25.1772 12.042 25.3132 12.02 25.4572 12.004C25.6052 11.984 25.7492 11.974 25.8892 11.974C26.2092 11.974 26.4652 12.012 26.6572 12.088C26.8532 12.16 26.9932 12.272 27.0772 12.424C27.1652 12.576 27.2092 12.774 27.2092 13.018C27.2092 13.166 27.1872 13.292 27.1432 13.396C27.0992 13.496 27.0452 13.582 26.9812 13.654C26.9172 13.722 26.8532 13.778 26.7892 13.822C26.7292 13.862 26.6812 13.892 26.6452 13.912C26.7772 13.964 26.8912 14.024 26.9872 14.092C27.0832 14.156 27.1592 14.248 27.2152 14.368C27.2712 14.488 27.2992 14.65 27.2992 14.854C27.2992 15.13 27.2512 15.358 27.1552 15.538C27.0632 15.714 26.9192 15.846 26.7232 15.934C26.5272 16.018 26.2772 16.06 25.9732 16.06Z"
                    fill="white"
                />
            </svg>
        </span>
    );
};

export default NotifictionsIcon;
